/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advantages_Sample_OverlappingInputs */

const en_advantages_sample_overlapping = /** @type {(inputs: Advantages_Sample_OverlappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[7]. In this dataset there are many overlapping labels (i.e. Woman and Person). Using a softmax`)
};

const es_advantages_sample_overlapping = /** @type {(inputs: Advantages_Sample_OverlappingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[7]. En este conjunto de datos hay muchas etiquetas superpuestas (p. ej., Mujer y Persona). Usando una función softmax`)
};

/**
* | output |
* | --- |
* | "[7]. In this dataset there are many overlapping labels (i.e. Woman and Person). Using a softmax" |
*
* @param {Advantages_Sample_OverlappingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const advantages_sample_overlapping = /** @type {((inputs?: Advantages_Sample_OverlappingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advantages_Sample_OverlappingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_advantages_sample_overlapping(inputs)
	return en_advantages_sample_overlapping(inputs)
});